<div>
  <!-- 閉じるボタン -->
  <button
    id="close-btn"
    class="!tw-absolute tw-top-1 tw-right-1 !tw-flex !tw-z-10"
    mat-icon-button
    mat-dialog-close
  >
    <mat-icon>close</mat-icon>
  </button>

  <form [formGroup]="formGroup" (submit)="submit()" class="tw-p-4">
    <div mat-dialog-title class="matp-dialog-title">ユーザー設定</div>
    <mat-dialog-content class="tw-w-full !tw-pt-2">
      <div class="tw-flex tw-gap-x-4">
        <div
          class="tw-flex tw-flex-col tw-gap-y-6 tw-w-full"
          [ngClass]="{
            'tw-ml-40': !updating,
            'tw-items-start': updating,
          }"
        >
          <!-- メールアドレス表示/編集 -->
          <div class="tw-min-w-[292px]">
            <div class="tw-text-[0.8em] tw-mb-2">メールアドレス</div>
            <div>{{ email }}</div>
          </div>

          <!-- パスワード -->
          @if (!updating) {
            <div class="tw-min-w-[292px]">
              <div class="tw-text-[0.8em] tw-mb-2">パスワード</div>
              <button
                mat-raised-button
                id="edit-mode-btn"
                color="primary"
                type="button"
                class="tw-w-48"
                (click)="openEditDialog()"
              >
                <mat-icon>passkey</mat-icon>
                <span>パスワード変更</span>
              </button>
            </div>
          } @else {
            <!-- 現在のパスワード -->
            <mat-form-field appearance="outline" floatLabel="always" class="tw-w-full">
              <mat-label>現在のパスワード</mat-label>
              <input
                matInput
                type="password"
                formControlName="oldPassword"
                name="oldPassword"
              />
              <mat-error
                *ngIf="formGroup.controls['oldPassword'].errors?.['required']"
              >
                パスワードを入力してください。
              </mat-error>
            </mat-form-field>
            <!-- 新しいパスワード -->
            <mat-form-field appearance="outline" floatLabel="always" class="tw-w-full">
              <mat-label>新しいパスワード</mat-label>
              <input
                matInput
                type="password"
                formControlName="password"
                name="password"
              />
              <mat-error
                *ngIf="formGroup.controls['password'].errors?.['required']"
              >
                パスワードを入力してください。
              </mat-error>
              <mat-error
                *ngIf="
                  formGroup.controls['password'].errors?.['minlength'] ||
                  formGroup.controls['password'].errors?.['maxlength']
                "
              >
                長さは8文字以上・32文字以下で入力ください。
              </mat-error>
              <mat-error
                *ngIf="formGroup.controls['password'].errors?.['pattern']"
              >
                英字・数字・記号を少なくとも1文字以上の組み合わせとしてください。
              </mat-error>
              <mat-error *ngIf="formGroup.controls['password'].errors?.['samePassword']">
                変更前とは異なるパスワードにしてください。
              </mat-error>
            </mat-form-field>
            <!-- 確認用パスワード -->
            <mat-form-field appearance="outline" floatLabel="always" class="tw-w-full">
              <mat-label>確認用パスワード</mat-label>
              <input
                matInput
                type="password"
                formControlName="passwordConfirm"
                name="passwordConfirm"
              />
              <mat-error
                *ngIf="
                  formGroup.controls['passwordConfirm'].errors?.['required']
                "
              >
                パスワードを入力してください。
              </mat-error>
              <mat-error
                *ngIf="
                  formGroup.controls['passwordConfirm'].errors?.['mismatch']
                "
              >
                入力されたパスワードが一致しません。
              </mat-error>
            </mat-form-field>
          }
          <!-- MFA -->
          @if (!mfaRequired) {
            @if (!updating) {
              <div class="tw-min-w-[292px]">
                <div class="tw-text-[0.8em] tw-mb-2">2要素認証ステータス</div>
                <div class="tw-flex-col tw-gap-x-4 tw-items-center">
                  @if (mfaStatus) {
                    <div class="tw-mb-2">認証済み</div>
                    <button
                      type="button"
                      mat-raised-button
                      class="tw-w-52"
                      color="accent"
                      (click)="disableMFA()"
                    >
                      <mat-icon>toggle_off</mat-icon>
                      <span>2要素認証を解除する</span>
                    </button>
                  } @else {
                    <div class="tw-mb-2">未認証</div>
                    <button
                      type="button"
                      mat-raised-button
                      class="tw-w-48"
                      color="accent"
                      (click)="enableMFA()"
                    >
                      <mat-icon>toggle_on</mat-icon>
                      <span>2要素認証する</span>
                    </button>
                  }
                </div>
              </div>
            }
          }
        </div>
      </div>
    </mat-dialog-content>

    <mat-dialog-actions class="tw-flex !tw-justify-center !tw-px-6 tw-gap-x-4">
      @if (updating) {
        <button
          id="cancel-btn"
          mat-raised-button
          class="tw-w-40"
          type="button"
          (click)="openDisplayDialog()"
        >
          <mat-icon>close</mat-icon>
          キャンセル
        </button>
        <button
          id="edit-btn"
          mat-raised-button
          color="accent"
          class="tw-w-40"
          type="submit"
          [disabled]="formGroup.invalid"
        >
          <mat-icon>done</mat-icon>
          <span>変更</span>
        </button>
      }
    </mat-dialog-actions>
  </form>
</div>
